import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=2f5a2853&scoped=true"
import script from "./CompanySetting.vue?vue&type=script&lang=js"
export * from "./CompanySetting.vue?vue&type=script&lang=js"
import style0 from "./CompanySetting.vue?vue&type=style&index=0&id=2f5a2853&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a2853",
  null
  
)

export default component.exports